import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { api } from "@/lib/api";
import { TID } from "@/lib/testIds";

export default function BreakingNewsBar() {
  const [items, setItems] = useState([]);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api
      .articles({ breaking: true, limit: 6 })
      .then((res) => setItems(res.items || []))
      .catch(() => setItems([]));
    api.siteSettings().then((s) => setSettings(s || {})).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  // Duplicate for seamless marquee
  const loop = [...items, ...items];

  const bg = settings.ticker_bg_color || "#00A6A6";
  const fg = settings.ticker_text_color || "#FFFFFF";

  return (
    <div
      data-testid={TID.breakingBar}
      className="border-b border-white/20 overflow-hidden"
      style={{ backgroundColor: bg, color: fg }}
    >
      <div className="container-wide flex items-stretch">
        <div
          className="flex items-center gap-2 pr-4 py-2 border-r border-white/25 flex-shrink-0 bg-nightblue -ml-4 sm:-ml-6 lg:-ml-8 pl-4 sm:pl-6 lg:pl-8"
          style={{ color: fg }}
        >
          <AlertCircle className="w-4 h-4" strokeWidth={2.2} />
          <span className="text-[11px] font-bold uppercase tracking-[0.16em]">Último momento</span>
        </div>
        <div className="flex-1 overflow-hidden py-2">
          <div className="flex gap-10 whitespace-nowrap animate-marquee will-change-transform pl-6">
            {loop.map((a, idx) => (
              <Link
                key={`${a.id}-${idx}`}
                to={`/noticia/${a.slug}`}
                className="text-sm font-medium hover:underline underline-offset-4"
                style={{ color: fg, textDecorationColor: fg }}
              >
                <span className="text-[11px] uppercase tracking-widest opacity-70 mr-2">
                  {a.main_category_name}
                </span>
                {a.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
